import React from 'react';
import PowerAppEnvironmentChangeTask from '../ManageCenter/PowerAppEnvironmentChangeTask';

const PowerAppEnvironmentTasks = ({environment, refresh}) => {

    const changeTasks = environment.changeTasks.map(t =>
        <div key={t.id} style={styles.taskDivStyle}>
            <PowerAppEnvironmentChangeTask
                change={t}
                refresh={refresh}
                created={t.requestDate}
            />
        </div>
    )

    const tasks = [...changeTasks]

    return (
            <div style={{ padding: '20px 20px 20px 20px', maxWidth: "680px", minWidth: "380px"}}>
                <div style={{ display: "flex", flexWrap: "wrap", marginLeft: "20px" }}>
                    {tasks}
                </div>
            </div>
    )
}

const styles = {
    taskDivStyle: {
        flex: "1",
        width: "50%",
        display: "flex",
        justifyContent: "center"
    }
}

export default PowerAppEnvironmentTasks;


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEnvironmentTasks.js